import { Component, inject } from '@angular/core';
import { MultiSectionFormPreviewService } from '../multi-section-form-preview.service';
import { HandleConditionalLogicService } from '../handle-conditional-logic.service';


@Component({
    selector: 'app-alert-no-logic',
    templateUrl: './alert-no-logic.component.html',
    styleUrls: ['./alert-no-logic.component.css'],
    standalone: true,
    imports: []
})
export class AlertNoLogicComponent {
  public msfps = inject(MultiSectionFormPreviewService);
  public hcl = inject(HandleConditionalLogicService);
}
